<template>
  <div>
    <el-row type="flex" :gutter="40" class="flex-wrap">
      <el-col :md="6">
        <ra-card :header="false">
          <template slot="content">
            <div class="organisation">
              <div class="title">
                <span>{{
                  organisation.name && organisation.name.charAt(0)
                }}</span>
                <h6>{{ organisation.name }}</h6>
              </div>
              <div class="info">
                <div>
                  <span>Status</span>
                  <el-tag
                    :type="
                      setType(organisation.status && organisation.status.label)
                    "
                    size="small"
                    >{{
                      organisation.status && organisation.status.label
                    }}</el-tag
                  >
                </div>
                <div>
                  <span>Created</span>
                  <p>
                    {{ mFormatDate(organisation.created_at, "Do MMM, YYYY") }}
                  </p>
                </div>
                <div>
                  <span>Updated</span>
                  <p>
                    {{ mFormatDate(organisation.modified_at, "Do MMM, YYYY") }}
                  </p>
                </div>
              </div>
            </div>
          </template>
        </ra-card>
      </el-col>
      <el-col :md="18">
        <el-tabs ref="tabs" v-model="tab" @tab-click="handleTabClick">
          <el-tab-pane label="Members" name="members">
            <organisation-members
              v-if="organisation && organisation.id"
              :organisation-id="organisation.id"
            />
          </el-tab-pane>
          <el-tab-pane
            label="Settings"
            name="settings"
            :disabled="!userCan('auth', 'organisation.update')"
          >
            <organisation-settings :organisation="organisation" />
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiConstants from "@/apiConstants";
import OrganisationMembers from "@/components/Organisation/Members/OrganisationMembers.vue";
import OrganisationSettings from "@/components/Organisation/OrganisationSettings.vue";

export default {
  name: "Organisation",
  components: {
    OrganisationSettings,
    OrganisationMembers
  },
  data() {
    return {
      showOrganisation: false,
      tab: "members",
      statusLabels: apiConstants.GLOBAL_STATUS_LABEL
    };
  },
  computed: {
    organisation() {
      return this.$store.getters.organisation.summary || {};
    }
  },
  mounted() {
    this.initTab();
  },
  methods: {
    handleTabClick(tab) {
      location.hash = tab.name;
    },
    initTab() {
      const initialTab =
        this.$route.hash !== "" ? this.$route.hash.substr(1) : "members";
      setTimeout(() => {
        this.tab = initialTab;
      }, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.organisation {
  .title {
    text-align: center;

    span {
      margin: 0 auto 12px;
      height: 64px;
      width: 64px;
      border-radius: 100px;
      background: #f5e8ea;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      font-weight: 500;
    }

    h6 {
      font-size: 1.105rem;
      margin-left: 10px;
    }
  }

  .info {
    margin-top: 20px;

    > div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 0;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);

      span {
        font-size: 0.875rem;
      }
    }
  }
  .actions {
    padding-top: 20px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
